export function isValidColor(str) {
    // Check for #RGB or #RRGGBB pattern
    const hexPattern = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/;

    return hexPattern.test(str);
}